import { Hourglass } from "react-loader-spinner";
import styles from "./main.module.css";

const Main = () => {
  return (
    <div className={styles.loader}>
      <Hourglass
        visible={true}
        height="70"
        width="70"
        ariaLabel="hourglass-loading"
        wrapperStyle={{}}
        wrapperClass=""
        colors={[ "#42795A","#335642"]}
      />
    </div>
  );
};

export default Main;
